import React, { useState } from "react"
import { themes } from "../themes.js"
import { useDispatch } from "react-redux"
import { setTheme } from "../store/reducers/general"

export function ThemeSelector() {
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const [selected, setSelected] = useState("blue")

    const handleSelect = (name) => {
        setSelected(name)
        dispatch(setTheme(name))
        setOpen(false)
    }

    return <div className={`palette-switcher ${open ? "open" : ""}`}>
        <div
            className="switcher-button noselect"
            onClick={() => setOpen(!open)}
        >
            🎨
        </div>
        {open && <>
            <div className='screen' onClick={() => setOpen(false)} style={{ zIndex: 1 }} />
            <div className="palette-menu noselect">
                {Object.entries(themes).map(([name, palette]) => (
                    <div
                        key={name}
                        className={`palette-option ${selected === name ? "selected" : ""}`}
                        style={{ backgroundColor: palette.main7 }}
                        onClick={() => handleSelect(name)}
                        title={name}
                    />
                ))}
            </div>
        </>}
    </div>
}
